import { Link } from 'react-router-dom';
import { site, stats } from '@/mocks/site';

const anchors = [
  { label: '内容方向', href: '#topics' },
  { label: '编辑精选', href: '#featured' },
  { label: '最新复盘', href: '#latest' },
  { label: '常见问题', href: '#faq' },
  { label: '联系投稿', href: '#submit' },
];

export default function HeroSection() {
  return (
    <section className="relative">
      <div className="relative h-[520px] w-full overflow-hidden md:h-[620px]">
        <img
          src={site.heroImage}
          alt={site.heroAlt}
          className="absolute inset-0 h-full w-full object-cover object-top"
        />
        <div className="absolute inset-0 bg-gradient-to-b from-black/55 via-black/40 to-black/65"></div>

        <div className="relative z-10 mx-auto flex h-full w-full max-w-7xl flex-col items-center justify-center px-4 text-center md:px-6">
          <span className="animate-float-up inline-flex items-center gap-2 whitespace-nowrap rounded-full border border-white/30 bg-white/10 px-4 py-1.5 text-xs text-white/90 backdrop-blur md:text-sm">
            <span className="flex h-4 w-4 items-center justify-center">
              <i className="ri-fire-line"></i>
            </span>
            娱乐热点 · 时间线复盘 · 舆论观察
          </span>

          <h1 className="animate-float-up mt-6 w-full">
            <span className="block font-heading text-4xl font-black tracking-tight text-white md:text-6xl">
              {site.name}
            </span>
            <span className="mt-3 block font-heading text-lg font-semibold text-white/90 md:text-2xl">
              深挖起势，理清脉络，吃瓜不迷路
            </span>
          </h1>

          <p className="animate-float-up mt-5 max-w-2xl text-sm leading-relaxed text-white/80 md:text-base">
            把一个热点从最早的那条动态开始排起，还原发酵、转向与收场的关键节点。
            不做情绪判断，只做公开信息的结构化整理。
          </p>

          <div className="animate-float-up mt-8 flex w-full flex-col items-center justify-center gap-3 sm:w-auto sm:flex-row">
            <Link
              to="/topics"
              className="inline-flex w-full cursor-pointer items-center justify-center gap-2 whitespace-nowrap rounded-full bg-primary-500 px-7 py-3 text-sm font-medium text-background-50 transition-colors hover:bg-primary-600 sm:w-auto"
            >
              <i className="ri-compasses-2-line"></i>
              浏览全部专题
            </Link>
            <Link
              to="/contact"
              className="inline-flex w-full cursor-pointer items-center justify-center gap-2 whitespace-nowrap rounded-full border border-white/40 bg-white/10 px-7 py-3 text-sm font-medium text-white backdrop-blur transition-colors hover:bg-white/20 sm:w-auto"
            >
              <i className="ri-send-plane-line"></i>
              我要投稿爆料
            </Link>
          </div>
        </div>
      </div>

      <div className="border-y border-background-200 bg-background-100">
        <div className="mx-auto flex w-full max-w-7xl flex-wrap items-center justify-center gap-x-2 gap-y-2 px-4 py-4 md:gap-x-4 md:px-6">
          {anchors.map((item) => (
            <a
              key={item.href}
              href={item.href}
              className="cursor-pointer whitespace-nowrap rounded-full px-4 py-1.5 text-sm text-foreground-700 transition-colors hover:bg-background-200 hover:text-foreground-950"
            >
              {item.label}
            </a>
          ))}
        </div>
      </div>

      <div className="bg-background-50">
        <div className="mx-auto grid w-full max-w-7xl grid-cols-2 gap-y-8 px-4 py-12 md:grid-cols-4 md:px-6 md:py-16">
          {stats.map((item) => (
            <div key={item.label} className="flex flex-col items-center text-center">
              <span className="font-heading text-3xl font-bold text-primary-600 md:text-4xl">{item.value}</span>
              <span className="mt-2 text-xs text-foreground-600 md:text-sm">{item.label}</span>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}